import React, { forwardRef } from 'react'
import L, { LatLngExpression } from 'leaflet'
import {
  MapContainer,
  // Marker,
} from 'react-leaflet'
// import defaultIcon from './DefaultIcon'
import useStyles from './styles'

interface Props {
  children?: React.ReactNode
  className?: string | undefined
}
const LeafletMap = forwardRef(({ className, children }: Props, ref) => {
  const classes = useStyles()

  const center: LatLngExpression = [33.66133522740873, 54.3633772520553]
  const corner1 = L.latLng(-90, -180)
  const corner2 = L.latLng(90, 180)
  const bounds = L.latLngBounds(corner1, corner2)

  return (
    <MapContainer
      ref={ref as any}
      center={center}
      maxBounds={bounds}
      zoom={6}
      minZoom={4}
      scrollWheelZoom
      zoomControl={false}
      className={className ? `${classes.mapContainer} ${className}` : classes.mapContainer}
    >
      {children}
      {/* <Marker position={center} icon={defaultIcon} /> */}
    </MapContainer>
  )
})

export default LeafletMap
